var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import cx from "clsx";
import { MenuCtaType } from "../../../types/menu";
import { CtaButton } from "./CtaButton";
import { CtaPhone } from "./CtaPhone";
import { CtaSearch } from "./CtaSearch";
var getCtaComponent = function (componentType) {
    switch (componentType) {
        case MenuCtaType.Button:
            return CtaButton;
        case MenuCtaType.Phone:
            return CtaPhone;
        case MenuCtaType.SearchField:
            return CtaSearch;
    }
    return null;
};
export var Cta = function (props) {
    var type = props.type;
    var baseClass = "last:pr-0";
    var paddingClass = "py-5 md:py-5 px-4";
    var textClass = "text-left text-text-secondary hover:text-primary-200 leading-none";
    var additionalTextClass = type === MenuCtaType.Phone ? "font-normal" : "font-semibold ";
    var transitionClass = "transition-text duration-200";
    var Component = getCtaComponent(type);
    var isButton = type === "button";
    var className = isButton
        ? baseClass
        : cx(baseClass, paddingClass, textClass, additionalTextClass, transitionClass);
    return Component && React.createElement(Component, __assign({}, props, { className: className }));
};
//# sourceMappingURL=Cta.js.map